import React from 'react';
import { number } from 'prop-types';
import MuiLinearProgress from '@material-ui/core/LinearProgress';
import useStyles from './styles';

const LinearProgress = ({ value }) => {
  const classes = useStyles();

  return (
    <MuiLinearProgress
      variant="determinate"
      className={classes.root}
      value={value}
      classes={{ barColorPrimary: classes.barColorPrimary, colorPrimary: classes.colorPrimary }}
    />
  );
};

LinearProgress.propTypes = {
  value: number,
};

export default LinearProgress;
